function imagesCollectionPage(){
  
    var $lista = $("div.collection-grid__wrapper > .grid.grid--uniform");
    var $elementosLi = $lista.find(".product-item");
    var $bannerOne = $('div.collection-content').attr('data-banner-1');
    var $bannerTwo = $('div.collection-content').attr('data-banner-2');
    var $linkOne = $('div.collection-content').attr('data-link-1');
    var $linkTwo = $('div.collection-content').attr('data-link-2');
  
    if($linkOne == undefined){
      var $divNuevoOne = $(
        '<div class="product-item imagen-collection-page__middle">' +
          '<div class="container-imagen">' +
            '<img src="' + $bannerOne + '">' +
          '</div>' +
        '</div>'
      );  
    } else {
      var $divNuevoOne = $(
        '<div class="product-item imagen-collection-page__middle">' +
          '<div class="container-imagen">' +
            '<a target="_blank" href="' + $linkOne + '">' +
              '<img src="' + $bannerOne + '">' +
            '</a>' +
          '</div>' +
        '</div>'
      );
    }
    
    if($linkTwo == undefined){
      var $divNuevoTwo = $(
        '<div class="product-item imagen-collection-page__middle">' +
          '<div class="container-imagen">' +
            '<img src="' + $bannerTwo + '">' +
          '</div>' +
        '</div>'
      );
    } else {
      var $divNuevoTwo = $(
        '<div class="product-item imagen-collection-page__middle">' +
          '<div class="container-imagen">' +
            '<a target="_blank" href="' + $linkTwo + '">' +
              '<img src="' + $bannerTwo + '">' +
            '</a>' +
          '</div>' +
        '</div>'
      );
    }
  
    if($elementosLi.length <= 6) {
      console.log('No se muestran los banners.');
    } else if ($elementosLi.length >= 7 && $elementosLi.length <= 12) {
      $elementosLi.eq(5).after($divNuevoOne);
    } else if ($elementosLi.length >= 13) {
      $elementosLi.eq(5).after($divNuevoOne);
      $elementosLi.eq(11).after($divNuevoTwo);
    };
  
};



$(document).ready(function() {
  imagesCollectionPage();
});


document.addEventListener('collection:reloaded', function() {
  console.log('Soy el Console.Log de las imagenes 🟢');
  imagesCollectionPage();
});
